<template>
  <v-dialog
    v-model="withdrawalDialog"
    max-width="50%"
    height="70vh"
    persistent
    :fullscreen="$vuetify.breakpoint.mobile"
  >
    <v-card flat elevation="0">
      <v-card-title>
        <span class="ml-4">DISCLAIMER</span>
        <v-spacer />
        <v-btn text color="error" @click="closeDialog">
          <v-icon>mdi-window-close</v-icon>
          <!-- close -->
        </v-btn>
      </v-card-title>
      <v-divider />
      <v-card-text
        class="overflow-y-auto overflow-x-hidden"
        style="max-height: 60vh"
      >
        <v-alert type="warning" class="mt-3" border="left" text>
          <span class="font">
            Download the <strong>WITHDRAWAL REQUEST FORM</strong> by clicking
            the button below. Fill in the fields and scan the document as it is
            required for the withdrawal process.
          </span>
          <v-card-actions>
            <v-spacer />
            <v-btn
              elevation="0"
              color="primary"
              href="https://kiseb.or.ke/wp-content/uploads/2022/05/Refund-and-Withdrawal-Request-Form.pdf"
              target="_blank"
              @click="closeDialog"
              class="mt-3"
            >
              download form
              <v-icon x-small right> mdi-open-in-new </v-icon>
            </v-btn>
          </v-card-actions>
        </v-alert>
      </v-card-text>
      <!-- <v-divider />
      <v-card-actions>
      </v-card-actions> -->
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  name: "ExamWithdrawalDialog",
  props: { examWithdrawalDialog: Boolean },
  computed: {
    withdrawalDialog: {
      get() {
        return this.examWithdrawalDialog;
      },
      set(value) {
        this.setExamWithdrawalModal(value);
      },
    },
  },
  methods: {
    closeDialog() {
      this.withdrawalDialog = false;
    },
    setExamWithdrawalModal(value) {
      this.$emit("setExamWithdrawalModal", value);
    },
  },
};
</script>
